import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { analytics } from '../services/analytics';
import { getCurrentQRParams } from '../utils/qrParser';
import BuildVersion from '../components/BuildVersion';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // QRコードパラメータを解析
    const qrParams = getCurrentQRParams();
    console.log('QR Params:', qrParams);

    // Track initial visit (detailed logs are now automatically saved)
    analytics.trackSessionStart();
  }, []);

  const handleStartAudioGuide = async () => {
    setIsLoading(true);

    try {
      // セッション作成のシミュレーション（後でFirebase Functions APIに置き換え）
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Session creation successful

      // 音声プレイヤーページに遷移
      navigate('/player2');
    } catch (error) {
      console.error('Session creation failed:', error);
      navigate('/error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="landing-page">
      {/* HEP-FIVE Primary Background */}
      <div className="background-container">
        <img
          src="/hep-five-primary-image.jpg"
          alt="HEP-FIVE Ferris Wheel View"
          className="background-image"
        />
        <div className="background-overlay"></div>
      </div>

      {/* Content Container */}
      <div className="content-container">
        {/* HEP-FIVE Logo */}
        <div className="logo-container">
          <img
            src="/hep-five-logo.svg"
            alt="HEP-FIVE"
            className="hep-five-logo"
          />
        </div>

        {/* Main Content */}
        <div className="main-content">
          <h1 className="title">
            Take to the skies with HEP FIVE
            <br />
            Your Osaka Journey in Sound
            <br />
            Discover Osaka from Above
            <br />
          </h1>

          <div className="subtitle">
            Experience Osaka’s charm from the sky with immersive sound. The
            Ferris Wheel turns into your personal audio tour of Osaka. See the
            city differently, hear its stories from above.
          </div>

          {/* Start Button */}
          <button
            className="start-button"
            onClick={handleStartAudioGuide}
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Start Your Audio Journey'}
          </button>

          {/* Headphone Recommendation */}
          <div className="headphone-recommendation">
            <span className="headphone-icon">🎧</span>
            <span className="headphone-text">
              Headphones recommended for the best experience
            </span>
          </div>

          {/* Credits Section */}
          <div className="credits-section">
            {/* Re:Sense Technology Credit */}
            <div className="tech-credit">
              <span className="credit-label">Powered by</span>
              <img
                src="/resense-streaming-logo.png"
                alt="Re:Sense STREAMING"
                className="resense-logo-completion"
              />
            </div>

            {/* Company Attribution */}
            <div className="company-credit">
              <span className="operated-by">Operated by</span>
              <span className="company-name">Clepseadra, Inc.</span>
            </div>

            {/* Copyright */}
            <div className="copyright">
              <span>© 2025 HEP FIVE OSAKA UMEDA</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Build Version Display */}
      <BuildVersion />
    </div>
  );
};

export default LandingPage;
